
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="mini" @click="$router.go(-1)">返回</el-button>
      <span>票据冲红流程</span>
    </div>
    <!-- end of title -->

    <!-- start of form -->
    <div class="form-box">
      <!-- start of 付款申请信息 -->
      <div class="back-color-fff mt-4">
        <span class="form-title">票据冲红流程信息</span>
        <el-form :model="formData" ref="formData">
          <el-row :gutter="24">

            <el-col :span="8">
              <el-form-item prop="hedgeReasonType" label-width="130px">
                <span slot="label"> <span style="color: red">*</span>冲红原因： </span>
                <el-select clearable style="width: 250px" v-model="formData.hedgeReasonType" placeholder="请选择">
                  <el-option v-for="item in getCodeListByKey('开票冲红原因')" :key="item.value" :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="isCurrentMonthHedge" label-width="130px">
                <span slot="label"> <span style="color: red">*</span>是否当月冲红： </span>
                <el-select clearable style="width: 250px" v-model="formData.isCurrentMonthHedge" placeholder="请选择">
                  <el-option label="是" value="Y"></el-option>
                  <el-option label="否" value="N"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="isDeduct" label-width="130px">
                <span slot="label"> <span style="color: red">*</span>对方是否抵扣： </span>
                <el-select clearable style="width: 250px" v-model="formData.isDeduct" placeholder="请选择">
                  <el-option label="是" value="Y"></el-option>
                  <el-option label="否" value="N"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item prop="invoiceDate" label-width="130px">
                <span slot="label">
                  <span style="color: red">*</span>开票日期：
                </span>
                <el-date-picker v-model="formData.invoiceDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  placeholder="请选择" clearable>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="isRetrieveDeduction" label-width="131px">
                <span slot="label"> <span style="color: red">*</span>抵扣联是否回收： </span>
                <el-select style="width: 249px" v-model="formData.isRetrieveDeduction" clearable placeholder="请选择">
                  <el-option label="是" value="Y"></el-option>
                  <el-option label="否" value="N"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item prop="businessCategory" label-width="130px">
                <span slot="label"> <span style="color: red">*</span>业务类型： </span>
                <el-select filterable style="width: 250px" v-model="formData.businessCategory" clearable
                  placeholder="请选择">
                  <el-option v-for="item in getCodeListByKey('合同内容分类')" :key="item.value" :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item prop="invoiceTenantGuid" label-width="130px">
                <span slot="label"> <span style="color: red">*</span>开票主体： </span>
                <el-select filterable style="width: 250px" v-model="formData.invoiceTenantGuid" placeholder="请选择"
                  clearable  @change="getTickList();formData.hedgeDataInfoList=null;formData.paymentTenantGuid=null;">
                  <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName"
                    :value="item.guid">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="paymentTenantGuid" label-width="130px">
                <span slot="label"> <span style="color: red">*</span>客户主体： </span>
                <el-select filterable style="width: 250px" v-model="formData.paymentTenantGuid" placeholder="请选择"
                  @change="getTickList();formData.hedgeDataInfoList=null;" clearable>
                  <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName"
                    :value="item.guid">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="130px" prop="relevance">
                <span slot="label"> <span style="color: red">*</span>冲红票据： </span>
                <el-select filterable style="width: 250px" v-model="formData.hedgeDataInfoList" placeholder="请选择" multiple
                  clearable @focus="hedgeFocus()">
                  <el-option v-for="item in tickList" :key="item.guid"
                    :label="item.invoiceDate + '_' + formatMoney(item.invoiceAccount) + '(元)'"
                    :value="item.guid">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item prop="upstreamInvoiceItem" label-width="130px">
                <span slot="label"> <span style="color: red">*</span>冲红说明： </span>
                <el-input style="width: 380px" v-model.trim="formData.remarks" placeholder="请输入" clearable maxlength="100"
                  :rows="3" resize="none" type="textarea" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- end of 付款申请信息 -->

      <!-- start of 流程审批 -->
      <div class="back-color-fff mt-4">
        <!-- <span class="form-title">流程审批</span> -->
        <div class="flow">
          <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
        </div>
      </div>
      <!-- end of 流程审批 -->

      <!-- start of bottom-btn -->
      <div class="back-color-fff submit_btn_wrap">
        <el-button type="defalut" class="cannel-btn" size="mini" @click="$router.go(-1)">取消</el-button>
        <el-button type="defalut" v-if="this.$route.query.type != 3" size="mini" @click="saveForm(false)">保存</el-button>
        <el-button type="primary" size="mini" @click="saveForm(true)">{{
          this.$route.query.type == 3 ? '重新提交' : '提交申请'
        }}</el-button>
      </div>
      <!-- end of bottom-btn -->
    </div>
    <!-- end of form -->
  </div>
</template>

<script>
import { bpmnroute } from '@/api/apiRoute';
export default {
  data() {
    return {
      fullscreenLoading: false,
      guid: '',
      serviceTenantList:[],
      tenantList:[],
      formData: {
        businessCategory: '1',//业务类型
        isRetrieveDeduction: null,//抵扣联是否回收
        invoiceDate: null,//开票日期
        isDeduct: null,//对方是否抵扣
        isCurrentMonthHedge: null,//是否当月冲红
        hedgeReasonType: null,//冲红原因
        invoiceTenantGuid: localStorage.guid,//开票主体
        paymentTenantGuid: null,//客户主体
        remarks: null,//冲红说明
        hedgeDataInfoList:null//冲红票据：
      },
      tickList: [],
      detailData: {},
      // 流程图相关
      iframeSh: false,
      iframeSrc: '',
    };
  },
  created() {
    // 获取流程数据
    this.getServiceTenantList();
    this.getTenantList(localStorage.guid);
    if (this.$route.query.guid) {
      this.guid = this.$route.query.guid;
      this.getDetail();
    } else {
      this.getApprovalList();
    }
  },
  watch: {
    "formData.invoiceTenantGuid"(val){
        if(val){
          this.formData.paymentTenantGuid = null;
          this.tenantList = [];
          this.getTenantList(val);
        }
    }
  },
  computed: {
  },
  methods: {
    //获取客户名称
    getServiceTenantList() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/select-service-tenants`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantList = res.data.data || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取开票主体
    getTenantList(val){
        let self = this;
        self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/select-send-tenants?serviceTenantGuid=${val}`).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getTickList() {
      let self = this;
      if (!this.formData.invoiceTenantGuid || !this.formData.paymentTenantGuid) return;
      let query = {
        "invoiceTenantGuid": this.formData.invoiceTenantGuid,
        "paymentTenantGuid": this.formData.paymentTenantGuid,
        "isQueryChild": true,
      };
      self.api
        .get(`/${serverConfig.msSalesPerformService}/upstream/get-plan-invoice-select-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tickList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    hedgeFocus(){
      if (!this.formData.paymentTenantGuid) {
        this.$message.error('请先选择需要冲红的客户名称');
        return;
      }
    },
    /**
     * 保存
     */
    saveForm(flg) {
      if (!this.checkForm()) return;
      this.postFormData(flg);
    },
    checkForm() {
      if (!this.formData.hedgeReasonType) {
        this.$message.error('冲红原因不能为空');
        return false;
      }
      if (!this.formData.isCurrentMonthHedge) {
        this.$message.error('是否当月冲红不能为空');
        return false;
      }
      if (!this.formData.isDeduct) {
        this.$message.error('对方是否抵扣不能为空');
        return false;
      }
      if (!this.formData.invoiceDate) {
        this.$message.error('开票日期不能为空');
        return false;
      }
      if (!this.formData.isRetrieveDeduction) {
        this.$message.error('抵扣联是否回收不能为空');
        return false;
      }
      if (!this.formData.businessCategory) {
        this.formData.businessCategory='1'//暂不展示
        // this.$message.error('业务类型不能为空');
        // return false;
      }
      if (!this.formData.invoiceTenantGuid) {
        this.$message.error('开票主体不能为空');
        return false;
      }
      if (!this.formData.paymentTenantGuid) {
        this.$message.error('客户主体不能为空');
        return false;
      }
      if (!this.formData.hedgeDataInfoList||!this.formData.hedgeDataInfoList.length) {
        this.$message.error('冲红票据不能为空');
        return false;
      }
      return true;
    },
    postFormData(flag) {
      let self = this;
      let postData = JSON.parse(JSON.stringify(this.formData));
    
      let invoiceTenantGuid = postData.invoiceTenantGuid;
      let paymentTenantGuid = postData.paymentTenantGuid;
      this.tenantList.forEach((item) => {
        if (item.guid == paymentTenantGuid) {
          postData.paymentTenantName = item.tenantName;
        }
      });
      this.serviceTenantList.forEach((item) => {
        if (item.guid == invoiceTenantGuid) {
          postData.invoiceTenantName = item.tenantName;
        }
      });
      let hedgeDataInfoList = postData.hedgeDataInfoList;
      let newHedgeDataInfoList = [];
      hedgeDataInfoList.forEach(m => {
        let list=this.tickList.filter(i=>m==i.guid)
        if(list.length>0){
          let obj=list[0]
          newHedgeDataInfoList.push({
            name: obj.invoiceDate + '_' + this.formatMoney(obj.invoiceAccount) + '(元)_' + obj.paymentTenantName,
            guid: m
          })
        }else{//冲红票据被使用了
          newHedgeDataInfoList.push({
            name: '',
            guid: m
          })
        }
        
        // this.tickList.forEach(n => {
        //   if (m == n.guid) {
        //     newHedgeDataInfoList.push({
        //       name: n.invoiceDate + '_' + this.formatMoney(n.invoiceAccount) + '(元)_' + n.paymentTenantName,
        //       guid: m
        //     })
        //     return
        //   }
        // })
      })
      
      console.log('newHedgeDataInfoList',newHedgeDataInfoList);
      postData.hedgeDataInfoList = newHedgeDataInfoList;
      postData.currentTenantGuid = localStorage.guid;
      postData.isSendFlowFlag = flag ? 'Y' : 'N';
      if (this.$route.query.guid) { // #重新提交
        postData['guid'] = this.$route.query.guid;
        postData['guidResubmit'] = this.$route.query.type == 2 ? this.$route.query.guid : null;
        this.fullscreenLoading = true;
        self.api.put(`/${serverConfig.msSalesPerformService}/invoice-apply-hedge/update`, postData).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (flag) {
              self.$message.success('提交成功！');
            } else {
              self.$message.success('保存成功！');
            }
            self.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        this.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/invoice-apply-hedge/add`, postData).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (flag) {
              self.$message.success('提交成功！');
            } else {
              self.$message.success('保存成功！');
            }
            self.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
    },
    //获取详情
    getDetail() {
      let str = this.$route.query.detail;
      let detail = JSON.parse (decodeURIComponent(str));
      detail.approveVO = detail.bizApproveVO;
      delete detail.bizApproveVO;
      let hedgeDataInfoList = detail.hedgeDataInfoList;
      let newHedgeDataInfoList = [];
      hedgeDataInfoList.forEach(item=>{
        newHedgeDataInfoList.push(item.guid);
      })
      detail.hedgeDataInfoList = newHedgeDataInfoList
      console.log(newHedgeDataInfoList)
      this.formData = detail;
      this.getTickList();
      this.getApprovalList();
      console.log(detail)
    },
  
    /**
     * 获取流程列表
     */
    async getApprovalList() {
      const userInfo = JSON.parse(localStorage.userInfo);
      const { approveVO } = this.formData;
      if (this.guid && approveVO.camundaInstanceId && approveVO.camundaDeploymentId) {
        this.iframeSh = true;
        this.iframeSrc = `${bpmnroute}/iframeBpmn?processInstanceId=${approveVO.camundaInstanceId}&camundaDeploymentId=${approveVO.camundaDeploymentId}&token=${localStorage.token}`;
      } else {
        try {
          const req = {
            tenantGuid: localStorage.guid,
            flowType: '00029',
            staffGuid: userInfo.staffGuid,
          };
          const res = await this.api.postJson(
            `/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`,
            req,
          );
          if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              this.iframeSh = true;
              this.iframeSrc = `${bpmnroute}/iframeBpmn?camundaDeploymentId=${res.data.data}&token=${localStorage.token}`;
            } else {
              this.$message.error('未获取到流程信息');
            }
          } else {
            this.$message.error(res.data.msg);
          }
        } catch (error) {
          this.$message.error('请求出错');
        }
      }
    },

    /**
     * 数字金额转大写
     * @param {*} num
     */
    convertToChinese(num) {
      const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      const decimals = ['角', '分'];
      const cnIntRadice = ['', '拾', '佰', '仟'];
      const cnIntUnits = ['', '万', '亿', '兆'];

      let cnNum = '';
      let isNegative = false;

      if (num < 0) {
        isNegative = true;
        num = Math.abs(num);
      }

      let parts = String(num).split('.');
      let integerPart = parts[0];
      let decimalPart = parts[1];

      if (Number(integerPart) === 0) {
        cnNum = digits[0];
        return cnNum;
      }

      let intLen = integerPart.length;
      let zeroCount = 0;

      for (let i = 0; i < intLen; i++) {
        let n = parseInt(integerPart.charAt(i));
        let p = intLen - i - 1;
        let q = p / 4;
        let m = p % 4;

        if (n === 0) {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            cnNum += digits[0];
          }
          zeroCount = 0;
          cnNum += digits[n] + cnIntRadice[m];
        }

        if (m === 0 && zeroCount < 4) {
          cnNum += cnIntUnits[q];
        }
      }

      if (decimalPart) {
        let decLen = decimalPart.length;
        for (let i = 0; i < decLen; i++) {
          let n = parseInt(decimalPart.charAt(i));
          if (n !== 0) {
            cnNum += digits[n] + decimals[i];
          }
        }
      }

      if (isNegative) {
        cnNum = '负' + cnNum;
      }

      return cnNum;
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
    seeDetail(row) {
      this.$router.push({
        path: '/settlementDocDetail',
        query: {
          guid: this.detailData.guid,
          guid: row.guid,
          productGuid: this.$route.query.productGuid,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: '';
  text-align: center;
  line-height: 37px;
}

.file-operate {
  display: flex;
}

.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}

.content {
  padding: 0px;
  margin: 0px;

  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;

    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }

    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .mt-4 {
    margin-top: 4px;
  }

  .form-box {
    margin-top: 4px;
    text-align: left;

    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
      font-weight: 500;
    }

    /deep/ .el-row {
      margin: 0px !important;
    }

    .el-form-item {
      margin-bottom: 8px;
    }

    .over-label /deep/ .el-form-item__label {
      line-height: 21px;
    }

    .el-input {
      width: 250px;
    }

    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;

      .el-button--primary {
        color: #ffffff;
      }
    }
  }

  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
  }

  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #d9d9d9;
  }

  .flow {
    background: #fff;
    padding-left: 20px;
  }

  .iframe-sty {
    width: 100%;
    border: none;
    height: 600px;
  }

  .detail-box {
    height: auto;
    border: 1px solid rgba(217, 217, 217, 1);
    margin: 0px 16px;
    padding: 16px 16px 100px 16px;
  }

  .cannel-btn {
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    color: #212121;
  }

  .content-main-box2 {
    height: 55vh;
    overflow-x: hidden;

    .search-area {
      padding: 16px 0px;
    }

    .el-table {
      border-left: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-bottom: 1px solid #d8d8d8;
    }
  }

  .file-img-box {
    display: flex;
    align-items: center;

    img {
      width: 26px;
      height: 26px;
      margin-right: 10px;
    }

    .see-btn {
      font-size: 14px;
      color: #4fa1a4;
      letter-spacing: 0;
      line-height: 21px;
      font-weight: 400;
      cursor: pointer;
      margin-left: 10px;
    }
  }

  .flex-between,
  .form-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .form-title-box {
    padding-right: 16px;
  }

  h2 {
    text-align: center;
  }

  .txt-right {
    text-align: right;

    span {
      margin: 0px 16px;
    }
  }

  .table1 {
    border: 1px solid rgba(217, 217, 217, 1);

    .header-div {
      background: #f2f2f2;
      font-size: 12px;
      color: #909399;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      height: 32px;
      line-height: 32px;
      font-weight: 500;
    }

    .tab-label {
      padding: 0px 10px;
      width: 200px;
      height: 32px;
      color: #212121;
      line-height: 32px;
      background: #fafafa;
      border-top: 1px solid rgba(229, 229, 229, 1);
      border-right: 1px solid rgba(229, 229, 229, 1);
    }

    .tab-value {
      text-align: right;
      padding: 0px 10px;
      width: calc(100% - 200px);
      height: 32px;
      line-height: 32px;
      border-top: 1px solid rgba(229, 229, 229, 1);
      color: #666666;
    }

    p {
      color: #666666;
    }

    .line-box {
      height: 32px;
      line-height: 32px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      padding-left: 10px;

      div:first-child {
        width: 80px;
        background: #fafafa;
        // border-top: 1px solid rgba(229, 229, 229, 1);
        border-right: 1px solid rgba(229, 229, 229, 1);
        font-weight: bold;
      }

      div:last-child {
        padding: 10px 6px;
        width: calc(100% - 80px);

        // border-top: 1px solid rgba(229, 229, 229, 1);
      }
    }
  }

  .table2,
  .table3 {
    border-left: 1px solid rgba(217, 217, 217, 1);
    border-right: 1px solid rgba(217, 217, 217, 1);
    border-bottom: 1px solid rgba(217, 217, 217, 1);
  }

  .table2 {
    margin: 16px 0px;
  }

  .info-box {
    width: calc(50% - 12px);
  }
}
</style>
